<template>
    <article>
        <p class="text-grey-70 pb-2">Employers looking for new staff benefit greatly from using Agency
            Central. Our site features an advanced search and filter system to find and contact local
            employment agencies or job specialists who may be further away. If you're not sure what
            salary bracket you should list the job at, we have detailed salary information to guide
            you.</p>
        <p class="text-grey-70 pb-2">Recruitment agencies provide you with the most complete staff
            solution, while saving you time. Their market expertise, salary knowledge, pre-interviewing
            and access to the best candidates ensures you have the best people in your business.</p>
        <p class="text-grey-70">Use the search above to get started.</p>
    </article>
</template>

<script>
export default {
    name: "EmployerInfo"
}
</script>
